import { ProductData } from 'types/ProductData';
import { StyledDiscountItems } from './style';
import { Button, Carousel } from '../../../../ui';
import { useIntl } from 'react-intl';
import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { carouselResponsive } from '../../../../config/config';
import PublicRoute from 'enums/publicRoutes';

interface DiscountItemsProps {
  products?: ProductData[];
  slidesPerRow?: number;
  children?: ReactNode;
}

const DiscountItems = ({
  products,
  slidesPerRow,
  children,
}: DiscountItemsProps) => {
  const intl = useIntl();
  const navigate = useNavigate();

  return (
    <StyledDiscountItems>
      <div className={'container'}>
        {children}
        <div className={'title'}>
          <h1>{intl.formatMessage({ id: 'general.buy_cheaper' })}</h1>
        </div>
        <div className={'row'}>
          <Carousel
            responsive={carouselResponsive}
            data={products}
            dots={true}
            slidesPerRow={slidesPerRow || 5}
            draggable={true}
          />
        </div>
      </div>

      <div className={'view-all-items-button'}>
        <Button
          type="primary"
          size={'large'}
          label={intl.formatMessage({ id: 'discount_items.view_items_button' })}
          onClick={() => {
            navigate(PublicRoute.PRODUCTS_ALL_DISCOUNTED);
          }}
        />
      </div>
    </StyledDiscountItems>
  );
};

export default DiscountItems;
